var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageDocumentActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36842 0H1.05263C0.473684 0 0 0.490909 0 1.09091V8.72727H1.05263V1.09091H7.36842V0ZM6.84211 2.18182H3.15789C2.57895 2.18182 2.11053 2.67273 2.11053 3.27273L2.10526 10.9091C2.10526 11.5091 2.57368 12 3.15263 12H8.94737C9.52632 12 10 11.5091 10 10.9091V5.45455L6.84211 2.18182ZM3.15789 10.9091V3.27273H6.31579V6H8.94737V10.9091H3.15789Z",
    fill: "#178FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageDocumentActive);
export default __webpack_public_path__ + "static/media/manage_document_active.bf7c80def2b9f8f623406e518479edba.svg";
export { ForwardRef as ReactComponent };